export const PATHS = {
  account: 'account',
  admin: {
    customers: 'customers',
    feedback: 'feedback',
    homepage: '/kh39sk39_dsf952',
    mlTasks: 'ml-tasks',
    recordingDetail: 'recordings/:recordingId',
    recordingDetailLink: (recordingId: string) => `/kh39sk39_dsf952/recordings/${recordingId}`,
    recordings: 'recordings',
    survey: 'survey',
    onscreen: 'onscreen',
    onscreenJob: 'onscreen/:jobId',
    onscreenJobLink: (jobId: string) => `/kh39sk39_dsf952/onscreen/${jobId}`,
  },
  any: '*',
  auth: 'auth',
  checkout: 'checkout',
  folders: 'folders',
  glossaries: 'glossaries',
  guestTrial: 'try',
  guestTrialCheckout: 'try/checkout',
  homepage: '/',
  pricing: 'pricing',
  project: 'project',
  recordingDetail: 'recording/:recordId',
  recordingEntry: 'recording-entry',
  recordingShare: 'share/recording/:sharing_id',
  recordingShareLink: (sharingId: string) => `/share/recording/${sharingId}`,
  records: 'records',
  spaces: 'spaces',
  translation: 'translation',
  trialShare: 'share/:sharing_id',
  voices: 'voices',
} as const;
